import React from 'react';
import { Images } from "../../components";
import { connect } from "react-redux";

class ScreenTitle extends React.Component {

	render() {
		const { match, hideIcon, title, sportTypesIcons } = this.props;

		let img = '';
		if (match && match.params.feed && match.params.sport) {
			img = sportTypesIcons && sportTypesIcons.filter((item) => {
				return item.sportTypesIconsID == match.params.sport && item.feedId == match.params.feed;
			});
		}

		let icon = img && img[0] ? img[0].sportTypesIconsName : '';

		return (
			<div className="strip">
				<div className="title">
					{
						(!hideIcon && icon) &&
						<img src={icon} alt="sport-icon" className="icon" />
					}

					<h1>{title}</h1>

					{
						(match && match.params.feed == 5) &&
						<div className="live">Live</div>
					}
				</div>
				{/* {
					image &&
					<div className="images">
						<img className="pic" src={image} />
						<img className="mask" src={Images.Strip_Mask} />
					</div>
				} */}
			</div>
		)
	}
}


const mapStateToProps = (state, props) => {
	return {
		sportTypesIcons: state.general.sportTypesIcons
	};
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ScreenTitle);

